import { SubCapabilityKey } from "@next-platform/packages-ts-types";
import { useApplicationCapabilitiesAllowed, useApplicationCapabilityReady } from "../../../infra/application/capabilities";
/** Sub-capability that lets a brand turn Rulebook attachment on or off for each kind of owner (as `lorebook.characterAttach` does). */
const ATTACH_CAPABILITY = {
    character: SubCapabilityKey.RulebookCharacterAttach,
    persona: SubCapabilityKey.RulebookPersonaAttach,
};
/**
 * Picking needs both: attaching to this kind of owner, and managing Rulebooks (the list is the user's own Rulebooks).
 * Capabilities report "not allowed" until they load, so only a loaded "no" gates the choice off; while they're unknown
 * nothing is fetched or shown, and a restored draft's pick is kept until they settle.
 */
export default function useRulebookAttachGate(ownerType) {
    const isAttachAllowed = useApplicationCapabilitiesAllowed(ATTACH_CAPABILITY[ownerType]);
    const isManageAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookManage);
    const isCapabilityReady = useApplicationCapabilityReady();
    const isGatedOff = isCapabilityReady && !(isAttachAllowed && isManageAllowed);
    return { isGatedOff, isEnabled: isCapabilityReady && !isGatedOff };
}
